import DEFAULT_CONFIG from '../OpSchedulerConfig';

/**
 * Merges consumer-provided config/overrides with DEFAULT_CONFIG and derives
 * the editable permissions and per-section configs used throughout the scheduler.
 */
function useSchedulerConfig(config) {
  const schedulerConfig = {
    ...DEFAULT_CONFIG,
    ...config,
  };

  const permissions = {
    startEditable: schedulerConfig.eventStartEditable,
    durationEditable: schedulerConfig.eventDurationEditable,
    createEnabled: schedulerConfig.eventCreateEnabled,
    updateEnabled: schedulerConfig.eventUpdateEnabled,
    deleteEnabled: schedulerConfig.eventDeleteEnabled,
  };

  // Deep-merge context menu config so consumers can override individual flags
  const contextMenuConfig = {
    ...DEFAULT_CONFIG.contextMenu,
    ...schedulerConfig.contextMenu,
  };
  const eventEditorConfig = {
    ...DEFAULT_CONFIG.eventEditor,
    ...schedulerConfig.eventEditor,
  };
  const settingsPanelConfig = {
    ...DEFAULT_CONFIG.settingsPanel,
    ...schedulerConfig.settingsPanel,
  };

  return {
    schedulerConfig,
    permissions,
    contextMenuConfig,
    eventEditorConfig,
    settingsPanelConfig,
  };
}

export default useSchedulerConfig;
